export class ControlsController {
  /**
   * @type {HTMLElement|null}
   * @private
   */
  _wrapper = null;

  _buttonClassPrefix = '.camera-control-button-';

  /**
   * @type {Map<string, AbortController>}
   * @private
   */
  _abortControllers = new Map();

  constructor(wrapper) {
    this._wrapper = wrapper;
    if (!this._wrapper) throw new Error('Controls wrapper must be provided.');
    this._wrapper.querySelectorAll('.button').forEach(button => button.classList.add('hide'));
  }

  ////////////////////////
  ////////////////////////

  __actionZoom(callback) {
    this._uniAction(callback, 'zoom');
  }

  __actionLight(callback) {
    this._uniAction(callback, 'light');
  }

  __actionSwitch(callback) {
    this._uniAction(callback, 'switch');
  }

  __actionPosition(callback) {
    this._uniAction(callback, 'position');
  }

  __actionCancel(callback) {
    this._uniAction(callback, 'cancel');
  }

  ////////////////////////
  ////////////////////////

  __positionToggle() {
    this._wrapper.classList.toggle('position-left');
  }

  __show() {
    this._wrapper.classList.add('show');
  }

  __hide() {
    this._wrapper.classList.remove('show');
  }

  __dispose() {
    this._abortControllers.forEach(controller => controller.abort());
    this._abortControllers.clear();
    this._wrapper = null;
  }

  _uniAction(callback, type) {
    const button = this._wrapper.querySelector(this._buttonClassPrefix + type);
    if (!button || !callback || this._abortControllers.has(type)) return;
    const abortController = new AbortController();
    button.addEventListener('click', e => callback?.(e), { signal: abortController.signal });
    this._abortControllers.set(type, abortController);
    button.classList.remove('hide');
  }
}
